import { IRootReducer } from "src/reducers";

export const takeIsAdminFlow = (state: IRootReducer): boolean =>
  state.main.isAdminFlow;
